import { NumericSettingsTitles } from "../types";
import { boostingPresets } from "../boosting/hooks/useBoostingDraft";

export const generalInformationNumericSettings: (keyof NumericSettingsTitles)[] =
  ["maximumResults"];

export const MISSING_NET_TEXT =
  "Please activate a Net in the Site configuration.";

export const campaignPresets = {
  default: "default",
  ...boostingPresets,
};
